var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import firebase from 'firebase/app';
import 'firebase/analytics';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/storage';
import { NGAPI } from './NGAPI';
import { NGAuth } from './NGAuth';
import { NGData } from './NGData';
import { NGDatabaseCommon } from './NGDatabaseCommon';
import { NGState } from './NGState';
import { NGStorage } from './NGStorage';
import { NGConfig } from './NGConfig';
export class NGBackend {
    constructor() {
        this._auth = new NGAuth(this);
        this._db = new NGDatabaseCommon();
        this._api = new NGAPI();
        this._data = new NGData();
        this._state = new NGState();
        this._storage = new NGStorage();
        this._configuration = new NGConfig();
    }
    init(config) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._firebaseApp) {
                yield this._firebaseApp.delete();
            }
            this._config = config;
            yield this._api.call('init', config.cid, config.aid, !!config.admin);
            const firebaseConfig = {
                apiKey: 'AIzaSyDjqe7ye_8zGu5ATIDw6bKg8oqmRFAF-K0',
                authDomain: 'ng-apps-93caf.firebaseapp.com',
                databaseURL: 'https://ng-apps-93caf.firebaseio.com',
                projectId: 'ng-apps-93caf',
                storageBucket: 'ng-apps-93caf.appspot.com',
                messagingSenderId: '1083546740317',
                appId: '1:1083546740317:web:95467e5d4c33dc38630fb4',
                measurementId: 'G-F3W03944HP',
            };
            this._firebaseApp = firebase.initializeApp(firebaseConfig);
            this.initAnalytics();
            this._auth.init();
            this._db.init(`/clients/${config.cid}`, this._firebaseApp.firestore());
            this._data.init(this._db, this._config.aid);
            this._state.init(this._db, this._config.aid);
            this._configuration.init(this._config, this._db);
            this._storage.init(this._config.cid, this._config.cid, this._firebaseApp.storage());
        });
    }
    initAnalytics() {
        if (!this._analytics) {
            this._analytics = firebase.analytics();
        }
        this._analytics.setUserProperties({
            app: this._config.aid,
            client: this._config.cid,
        });
    }
    get auth() {
        return this._auth;
    }
    get api() {
        return this._api;
    }
    get app() {
        return this._firebaseApp;
    }
    get cid() {
        return this._config ? this._config.cid : '';
    }
    get aid() {
        return this._config ? this._config.aid : '';
    }
    get db() {
        return this._db;
    }
    get data() {
        return this._data;
    }
    get state() {
        return this._state;
    }
    get storage() {
        return this._storage;
    }
    get config() {
        return this._configuration;
    }
}
//# sourceMappingURL=NGBackend.js.map